import EdoReporting from "./EdoReporting";

export default EdoReporting;